var DefaultGuardModel = /** @class */ (function () {
    function DefaultGuardModel() {
        var _this = this;
        this.match = function (request, policy) {
            return (_this.matchSubject(request.subject, policy.subject) &&
                _this.matchResource(request.resource, policy.resource) &&
                _this.matchAction(request.action, policy.action));
        };
    }
    DefaultGuardModel.prototype.matchSubject = function (requestSubject, policySubject) {
        return requestSubject.role === policySubject.role;
    };
    DefaultGuardModel.prototype.matchResource = function (requestResource, policyResource) {
        return requestResource.name === policyResource.name;
    };
    DefaultGuardModel.prototype.matchAction = function (requestAction, policyAction) {
        return requestAction.split(',').every(function (i) { return policyAction.split(',').includes(i); });
    };
    DefaultGuardModel.prototype.effect = function (request, policyList) {
        var _this = this;
        return policyList.some(function (policy) { return _this.match(request.toJS(), policy.toJS()); });
    };
    return DefaultGuardModel;
}());
export { DefaultGuardModel };
//# sourceMappingURL=DefaultGuardModel.js.map